import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { isNil } from 'lodash-es';
import { OrganizationRole } from '../services/application.do';
import { MsalService } from '@azure/msal-angular';
import { ApplicationContextService } from '../services/application-context.service';
import { OrganizationRoleService } from '../services/application.service';
import { Subject, takeUntil } from 'rxjs';

export interface IRoleSelectFormParams {
  /** OrganizationRole referenceNames to filter out of the picker (typically the ones already bound by the caller). */
  excludedRoleNames: string[];
}

@Component({
  selector: 'app-role-select-form',
  templateUrl: './role-select-form.component.html',
  standalone: false
})
export class RoleSelectFormComponent implements OnInit, OnDestroy {

  private readonly _destroying$ = new Subject<void>();

  selected: OrganizationRole[];
  allowSelection = true;
  canManage = false;

  list: OrganizationRole[];
  private allRoles: OrganizationRole[] = [];

  constructor(
    private dialogRef: MatDialogRef<RoleSelectFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IRoleSelectFormParams,
    private authService: MsalService,
    private organizationService: OrganizationRoleService,
    private applicationContextService: ApplicationContextService
  ) { }

  ngOnInit(): void {
    this.applicationContextService.currentOrganization$
      .pipe(takeUntil(this._destroying$))
      .subscribe(org => {
        if (org) {
          this.loadOrgRoles();
        }
      });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  onSaveClicked() {
    this.dialogRef.close(this.selected);
  }

  onCancelClicked() {
    this.dialogRef.close();
  }

  get canAdd() {
    return this.authService.instance.getActiveAccount().tenantId === this.applicationContextService.getCurrentOrganization()?.tenantId;
  }

  loadOrgRoles() {
    this.organizationService.getAll().subscribe(result => {
      this.allRoles = result;
      this.filter();
    });
  }

  filter(fullTextSearch?: string) {
    const excluded = new Set(this.data.excludedRoleNames);
    let filtered = this.allRoles.filter(r => !excluded.has(r.referenceName));
    if (!isNil(fullTextSearch) && fullTextSearch.length > 0) {
      const text = fullTextSearch.toLocaleLowerCase();
      filtered = filtered.filter(r => r.referenceName.toLocaleLowerCase().includes(text));
    }
    this.list = filtered;
  }

  isSameRole(role1: OrganizationRole, role2: OrganizationRole) {
    return role1.id === role2.id;
  }
}
